// @flow

const CLAIM_COPY = 'Claim Account';
const FORGOT_COPY = 'Forgot Password';
const FORGOT_SUB_HEADER = 'Enter your email';
const RESET_SUB_HEADER = 'Set your new password';
const RESET_COPY = 'Reset Password';

export { CLAIM_COPY, FORGOT_COPY, FORGOT_SUB_HEADER, RESET_SUB_HEADER, RESET_COPY };



// WEBPACK FOOTER //
// ./src/containers/password-form/constants.js